<template>
    <div>
        <div v-html="renderedContent" class="markdown-content"></div>
    </div>
</template>

<script>
import { marked } from 'marked'

export default {
    props: {
        markdownContent: {
            type: String,
            default: ''
        },
        typingSpeed: {
            type: Number,
            default: 10
        }
    },
    data() {
        return {
            renderedContent: '',
            fullContent: '',
            charIndex: 0,
            typingInterval: null
        }
    },
    watch: {
        markdownContent: {
            handler(newContent) {
                // เมื่อ markdown เปลี่ยน ให้เริ่มการพิมพ์ใหม่
                this.fullContent = this.renderMarkdown(newContent)
                this.resetTyping()
            },
            immediate: true
        }
    },
    beforeDestroy() {
        clearInterval(this.typingInterval)
    },
    methods: {
        renderMarkdown(text) {
            if (text === "###loading###" || text === "") {
                return "";
            }

            if (text.includes("```json") && text.includes('"student_info":')) {
                return 'Please refresh answer !!';
            }

            if (text === "\n") {
                return 'Please refresh answer !!';
            }
            return marked.parse(text.replace('```', ''));
        },
        startTyping() {
            this.typingInterval = setInterval(() => {
                if (this.charIndex < this.fullContent.length) {
                    this.renderedContent += this.fullContent.charAt(this.charIndex)
                    this.charIndex++
                } else {
                    clearInterval(this.typingInterval)
                }
            }, this.typingSpeed)
        },
        resetTyping() {
            clearInterval(this.typingInterval)
            this.renderedContent = ''
            this.charIndex = 0
            this.startTyping()
        }
    }
}
</script>

<style>
.markdown-content {
    font-family: Arial, sans-serif;
    line-height: 1.6;
}

.markdown-content h1 {
    color: #000000;
}

.markdown-content strong {
    font-weight: bold;
    color: #000000;
}

.markdown-content em {
    font-style: italic;
    color: #3498db;
}
</style>